import React from 'react';
import { CreditCardType } from '../domains/payment-information.domain';

const CARD_FORMAT = {
  VISA: [4, 4, 4],
  MASTER: [4, 4, 4],
  AMEX: [4, 6, 1],
};
export const getCreditCardDots = (creditCardType: CreditCardType) => {
  if (!creditCardType) return '';
  const format = CARD_FORMAT[creditCardType];
  return (
    <div className="d-flex container-dot-groups">
      {format.map((groupSize, groupIndex) => (
        <div key={groupIndex} className={`card-dot-group dot-group${groupIndex + 1}`}>
          {Array.from({ length: groupSize }).map((_, dotIndex) => (
            <span key={dotIndex} className="card-dot"></span>
          ))}
        </div>
      ))}
    </div>
  );
};
